import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const csvEscape = (v) => {
  const s = v == null ? "" : String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

// columns: [{ header, accessor(row) | key }]
export const exportCSV = (filename, columns, rows) => {
  const header = columns.map((c) => csvEscape(c.header)).join(",");
  const body = rows
    .map((r) => columns.map((c) => csvEscape(c.accessor ? c.accessor(r) : r[c.key])).join(","))
    .join("\n");
  const blob = new Blob([`${header}\n${body}`], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;
  a.click();
  URL.revokeObjectURL(url);
};

export const exportPDF = (title, columns, rows) => {
  const doc = new jsPDF({ orientation: columns.length > 5 ? "landscape" : "portrait" });
  doc.setFontSize(15);
  doc.text(title, 14, 16);
  doc.setFontSize(9);
  doc.setTextColor(120);
  doc.text(`Xurray Mart · Generated ${new Date().toLocaleString()}`, 14, 22);
  autoTable(doc, {
    startY: 27,
    head: [columns.map((c) => c.header)],
    body: rows.map((r) => columns.map((c) => {
      const v = c.accessor ? c.accessor(r) : r[c.key];
      return v == null ? "" : String(v);
    })),
    styles: { fontSize: 8, cellPadding: 2 },
    headStyles: { fillColor: [234, 88, 12], textColor: 255 }, // orange
    alternateRowStyles: { fillColor: [255, 247, 237] },
    margin: { left: 14, right: 14 },
  });
  doc.save(`${title.replace(/\s+/g, "_").toLowerCase()}.pdf`);
};
